module.exports = __webpack_public_path__ + "img/step1.60ca0947.png";